
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/giveaway/[slug]",
      function () {
        return require("private-next-pages/[locale]/giveaway/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/giveaway/[slug]"])
      });
    }
  